import { useMemo } from 'react';
import useManaged from '../use/managed';
import useRelated from '../use/related';
import useRoles from '../use/roles';
import derive from './derive';

/**
 * @param {Object} me (user)
 * @param {Object} snapshot
 * @returns {Function}
 */
export default function useDeriveRelationship(me, snapshot) {
  const meId = me?.person?.uuid;
  const relatedEntities = useRelated(snapshot);
  const managedEntities = useManaged(snapshot, relatedEntities, meId);
  const roleSet = useRoles(me);

  return useMemo(() => {
    return derive(me, relatedEntities, managedEntities, roleSet);
  }, [snapshot?.__hash, roleSet]);
}
